import { ReactNode } from 'react';
import { Box, Paper } from '@mui/material';

import InvoicePageHeader, { InvoicePageHeaderProps } from './InvoicePageHeader';

import { croissantColors } from 'theme/croissantColors';

// The real tool's cards float on the beige page with a soft shadow on every edge. The theme's card
// shadows use a negative spread that hides it at the sides, so only their colour is borrowed here.
const CARD_STYLE = { boxShadow: `0px 4px 24px ${croissantColors.shadow.strong}` };

interface InvoicePageLayoutProps extends InvoicePageHeaderProps {
    main: ReactNode;
    side: ReactNode;
}

/** The real tool's two-card page: white cards on the beige page, a fixed-width panel on the right. */
export default function InvoicePageLayout({ main, side, ...header }: Readonly<InvoicePageLayoutProps>) {
    return (
        <Box sx={{ width: '100%' }}>
            <InvoicePageHeader {...header} />
            <Box
                sx={{
                    bgcolor: 'cement.50',
                    p: { xs: 2, md: 3 },
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', lg: 'minmax(0, 1fr) 340px' },
                    gap: { xs: 2, md: 3 },
                }}>
                <Paper elevation={0} sx={{ ...CARD_STYLE, p: { xs: 3, md: 5 } }}>
                    {main}
                </Paper>
                <Paper
                    elevation={0}
                    sx={{ ...CARD_STYLE, p: { xs: 3, md: 3.5 }, display: 'flex', flexDirection: 'column' }}>
                    {side}
                </Paper>
            </Box>
        </Box>
    );
}
